import { render, staticRenderFns } from "./richcontent.vue?vue&type=template&id=eb494f9a&"
import script from "./richcontent.js?vue&type=script&lang=js&"
export * from "./richcontent.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports